import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import {
  Rocket, LayoutGrid, Calendar, CheckSquare, Archive,
  Users, Settings, LogOut, Home
} from 'lucide-react';

const Sidebar = ({ mobile, onClose }) => {
  const location = useLocation();
  const { logout } = useAuth();

  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Dashboard' },
    { path: '/board', icon: LayoutGrid, label: 'Board' },
    { path: '/calendar', icon: Calendar, label: 'Kalender' },
    { path: '/tasks', icon: CheckSquare, label: 'Aufgaben' },
    { path: '/archive', icon: Archive, label: 'Archiv' },
    { path: '/contacts', icon: Users, label: 'Kontakte' },
  ];

  const bottomItems = [
    { path: '/settings', icon: Settings, label: 'Einstellungen' },
  ];

  const isActive = (path) => location.pathname === path;

  const handleClick = () => {
    if (mobile && onClose) onClose();
  };

  return (
    <aside className={`${mobile ? 'w-full h-full' : 'hidden md:flex w-64'} flex-col glass-sidebar h-screen sticky top-0`}>
      {/* Logo */}
      <div className="p-6 border-b border-white/10 dark:border-white/5">
        <Link to="/dashboard" className="flex items-center gap-3" onClick={handleClick}>
          <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-violet-500 rounded-xl flex items-center justify-center shadow-lg shadow-indigo-500/25">
            <Rocket className="w-5 h-5 text-white" />
          </div>
          <span className="font-bold text-lg text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>
            JaySmart
          </span>
        </Link>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={handleClick}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
              isActive(item.path)
                ? 'bg-gradient-to-r from-indigo-500 to-violet-500 text-white shadow-lg shadow-indigo-500/25'
                : 'text-muted-foreground hover:bg-white/20 dark:hover:bg-white/10 hover:text-foreground'
            }`}
          >
            <item.icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
      </nav>

      {/* Bottom Navigation */}
      <div className="p-4 border-t border-white/10 dark:border-white/5 space-y-1">
        {bottomItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            onClick={handleClick}
            className={`flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
              isActive(item.path)
                ? 'bg-gradient-to-r from-indigo-500 to-violet-500 text-white shadow-lg shadow-indigo-500/25'
                : 'text-muted-foreground hover:bg-white/20 dark:hover:bg-white/10 hover:text-foreground'
            }`}
          >
            <item.icon className="w-5 h-5" strokeWidth={1.5} />
            <span className="font-medium">{item.label}</span>
          </Link>
        ))}
        
        <button
          onClick={() => {
            handleClick();
            logout();
          }}
          className="w-full flex items-center gap-3 px-4 py-3 rounded-xl text-red-500 hover:bg-red-500/10 transition-colors"
        >
          <LogOut className="w-5 h-5" strokeWidth={1.5} />
          <span className="font-medium">Abmelden</span>
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
